module.exports = __webpack_public_path__ + "media/images/flags/mp-3a025f8241385eda2da6b9bd60d80977.svg";